<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Boards'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Boards'
        };
    },

    computed: {
        options() {
            return { emptyRow: 'Hidden' };
        },

        labels() {
            return [
                { value: 'name', width: '200px' },
                {
                    value: 'description',
                    width: '400px',
                    filter: 'truncate'
                },
                {
                    text: 'Status',
                    value: 'isPublic',
                    width: '200px',
                    filter: () => 'Public',
                    type: 'boolean'
                },
                {
                    text: 'Blocked Add Posts By Users',
                    value: 'isBlockedAddPostsByUsers',
                    width: '200px',
                    type: 'boolean',
                    isBadge: true,
                    badgeOptions: {
                        trueVariant: 'danger',
                        falseVariant: 'success'
                    }
                },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'boards/index',
            deleteItem: 'boards/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/boards/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/boards/add');
        }
    }
};
</script>
